import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { sortListByKey } from "../../../helpers/accounting-helper";

interface Props {
  dataToSort: any;
  sortOptionsMap: any;
  handleSort: any;
}
function SortFilter({ dataToSort, sortOptionsMap, handleSort }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [sortTypeClass, setSortTypeClass] = useState<string>('ic-sort-items');
  const handleClose = () => {
    setAnchorEl(null);
  };
 
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange= (sortOptions: any)=>{
    handleSort(
      sortListByKey(
        dataToSort,
        sortOptions.getKey,
        sortOptions.type
      )
    );
    setSortTypeClass(sortOptions.class)
  }
  
  return (
    <div>
      {" "}
      <div className={`!p-[8px] gap-1 cursor-pointer whitespace-nowrap border rounded-[6px] hover:border-black hover:shadow-[0px_3px_6px_#00000029] flex justify-center items-center overflow-hidden text-[13px]  ${open? " border-black":"border-[#3a5e8b1a]"}`} onClick={handleClick}>
        <span className="text-[#858585]">Sort</span>
        <span>:</span>
        <span
          className="ml-2 text-[#397EF5]"
        >
          <div className={`w-[18px] rista-sprite ${sortTypeClass} ml-[1%]`}></div>
        </span>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {sortOptionsMap.map((sortOptions: any, index: any) => {
          return (
            <MenuItem onClick={handleClose} key={index}>
              <p className="text-[14px]" onClick={() => handleChange(sortOptions)}>
                {sortOptions.label}
              </p>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}

export default SortFilter;
